import React from "react";

// Hook-Form
import { FieldValues, UseControllerReturn } from "react-hook-form";
// Material
import { InputBaseComponentProps } from "@mui/material";
// Say Lib
import { CustomTextFieldProps } from "../../../Atoms/Inputs/TextField/types";
import Text from "../../../Atoms/Text";
import TextField from "../../../Atoms/Inputs/TextField";
import ErrorMessage from "../../../Atoms/ErrorMessage";
import withControl from "../../../../hoc/withFormControl";
// Utils

export type IHookTextField = CustomTextFieldProps & {
  name: string;
  showCharChount?: boolean;
  inputProps?: InputBaseComponentProps;
  controllerFields: UseControllerReturn<FieldValues, string>;
  maxlength?: number;
  callback?: (event: React.SyntheticEvent<Element, Event>) => void;
};

/**
 * @param control - control from useForm (react-hook-form)
 * @param name - field name
 * @returns JSX.Element
 */
const HookTextField = ({
  name,
  showCharChount = false,
  inputProps,
  helperText,
  callback,
  controllerFields: {
    field: { ref, value, onChange, ...fieldProps },
    fieldState: { error },
    formState: { errors }, //touchedFields, dirtyFields }, <- future use
  },
  ...rest
}: IHookTextField): JSX.Element => {
  /**
   * calculate and display current character count
   */
  const getCharCount = () => {
    if (showCharChount && value && inputProps?.maxLength) {
      const charCount = value.length;
      const maxLength = inputProps.maxLength;
      const weight = charCount >= maxLength ? 500 : 400;
      return (
        <Text
          data-testid="text-textfield-charcount"
          weight={weight}
          emphasis="medium_low"
          variant="body2"
          sx={{ mt: 2, ml: 1 }}
        >
          {charCount}/{maxLength} Characters
        </Text>
      );
    }
    return null;
  };

  /**
   * trigger side-effect if needed
   */
  const handleChange = (e: React.SyntheticEvent<Element, Event>) => {
    if (callback) {
      callback(e);
    }
    onChange(e);
  };

  return (
    <div>
      <div>
        <TextField
          {...fieldProps}
          inputProps={inputProps}
          value={value}
          error={!!error}
          helperText={errors[name] ? undefined : helperText}
          onChange={handleChange}
          {...rest}
          inputRef={ref}
        />
      </div>
      {getCharCount()}
      <ErrorMessage errors={errors} name={name} />
    </div>
  );
};

export default withControl(HookTextField, "");
